<script setup lang="ts">
  import type { Attachment } from '@stuut/api/models';
  import { Progress } from '@ui/components/progress';

  interface Props {
    attachment: Attachment;
    filesize?: string;
    progressValue?: number;
  }

  withDefaults(defineProps<Props>(), {
    progressValue: 0,
  });
</script>

<template>
  <div class="bg-secondary p-3.5 space-y-1 rounded flex-col items-center group">
    <div class="flex flex-nowrap items-center min-w-0 flex-1 gap-1.5 mr-16">
      <strong class="line-clamp-1 min-w-0">{{ attachment?.name }}</strong>
      <span class="text-muted-foreground whitespace-nowrap">{{ filesize }}</span>
    </div>

    <div class="flex flex-nowrap items-center w-full">
      <Progress :model-value="progressValue" class="h-1.5 flex-1" />

      <div class="w-16 shrink-0 flex justify-end items-center gap-x-2">
        <span class="text-muted-foreground text-xs whitespace-nowrap">
          {{ Math.round(progressValue) }}%
        </span>

        <i
          v-if="attachment?.is_uploading"
          class="fa fa-spinner-third animate-spin text-muted-foreground text-xs"
        />
        <i v-else class="fa fa-check-circle text-success" />
      </div>
    </div>
  </div>
</template>

<style scoped></style>
